<script setup>
const props = defineProps({
    filterId: { type: String, required: true },
    label:    { type: String, required: true },
    options:  { type: Array, required: true },
});

const model = defineModel({ default: null });

const clear = () => { model.value = null; };

defineExpose({ clear });
</script>

<template>
    <b-field :label="label" custom-class="mb-3">
        <b-select
            :id="filterId"
            v-model="model"
        >
            <option :value="null">-- {{ $t('filters.all_options') }} --</option>
            <option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
            >{{ option.label }}</option>
        </b-select>
    </b-field>
</template>
